import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

export async function searchTenants(query) {
  const response = await fetch(`${API_BASE}/tenants/search?q=${encodeURIComponent(query)}`)
  if (!response.ok) throw new Error('Error al buscar inquilinos')
  return response.json()
}